import React from 'react';
import { PageContainer } from '../../../../styles/styles';
import LinkCard from '../../../../components/Cards/Link';
import TabMenu from '../../../../components/TabMenu';
import { solicitacaoSegundaViaTabs, carteirinhaDigitalTabs } from '../Tabs';
import * as S from './styles';

function SelecionarCard() {
    return (
        <PageContainer>
            <S.ContainerItem>
                <S.DivItem>
                    <TabMenu components={carteirinhaDigitalTabs} />
                    <LinkCard
                        link="/dados_beneficiario/carterinha_digital"
                        title="Carteirinha digital"
                        desc="Solicite a carteirinha digital."
                        icons={{ left: { name: 'badge' } }}
                    />
                </S.DivItem>
                <S.DivItem>
                    <TabMenu components={solicitacaoSegundaViaTabs} />
                    <LinkCard
                        link="/dados_beneficiario/pesquisar_beneficiario"
                        title="Segunda via de carteirinha"
                        desc="Solicite a segunda via."
                        icons={{ left: { name: 'badge' } }}
                    />
                </S.DivItem>
            </S.ContainerItem>
        </PageContainer>
    );
}

export default SelecionarCard;
